import Header from 'components/Header/Header';
import { withHeaderProps } from 'viewModel/header/withHeaderProps';

export default withHeaderProps(Header);
